export function resetParameterState<State extends Record<PropertyKey, any>, Option extends keyof State>(
  prev: State,
  option: Option,
  defaults: State
): State {
  return {
    ...prev,
    [option]: defaults[option],
  };
}
